/**
 * Vehicle Insurance Claiming Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { GdvFormDataDto } from '../model/gdvFormDataDto';
import { InsuranceClaimDto } from '../model/insuranceClaimDto';
import { InsuranceClaimListItemDto } from '../model/insuranceClaimListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InsuranceClaimingViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingView/gdv/allFormData AmsResource:{country}/{business} 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGdvFormData(observe?: 'body', reportProgress?: boolean): Observable<GdvFormDataDto>;
    public getGdvFormData(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GdvFormDataDto>>;
    public getGdvFormData(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GdvFormDataDto>>;
    public getGdvFormData(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GdvFormDataDto>(`${this.basePath}/api/InsuranceClaimingView/gdv/allFormData`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingView/{repairEstimateSessionId} AmsResource:{country}/{business}/RepairEstimateSession/{repairEstimateSessionId} 
     * @param repairEstimateSessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInsuranceClaim(repairEstimateSessionId: string, observe?: 'body', reportProgress?: boolean): Observable<InsuranceClaimDto>;
    public getInsuranceClaim(repairEstimateSessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InsuranceClaimDto>>;
    public getInsuranceClaim(repairEstimateSessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InsuranceClaimDto>>;
    public getInsuranceClaim(repairEstimateSessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (repairEstimateSessionId === null || repairEstimateSessionId === undefined) {
            throw new Error('Required parameter repairEstimateSessionId was null or undefined when calling getInsuranceClaim.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InsuranceClaimDto>(`${this.basePath}/api/InsuranceClaimingView/${encodeURIComponent(String(repairEstimateSessionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingView/activeByUsersBusiness AmsResource:{country}/{business} 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInsuranceClaimByUserBusiness(observe?: 'body', reportProgress?: boolean): Observable<Array<InsuranceClaimListItemDto>>;
    public getInsuranceClaimByUserBusiness(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InsuranceClaimListItemDto>>>;
    public getInsuranceClaimByUserBusiness(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InsuranceClaimListItemDto>>>;
    public getInsuranceClaimByUserBusiness(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<InsuranceClaimListItemDto>>(`${this.basePath}/api/InsuranceClaimingView/activeByUsersBusiness`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
